export default "__VITE_ASSET__89579a22__"